module.exports = __webpack_public_path__ + "img/img_07.806bada5.gif";